import create from 'zustand';
import { combine } from 'zustand/middleware';

const accessTokenKey = 'accessToken';
const refreshTokenKey = 'refreshToken';

const getDefaultValues = () => {
    try {
        return {
            accessToken: localStorage.getItem(accessTokenKey) || '',
            refreshToken: localStorage.getItem(refreshTokenKey) || ''
        };
    } catch {}

    return {
        accessToken: '',
        refreshToken: ''
    };
};

export const useTokenStore = create(
    combine(getDefaultValues(), (set) => ({
        setTokens: (x) => {
            try {
                localStorage.setItem(accessTokenKey, x.accessToken);
                localStorage.setItem(refreshTokenKey, x.refreshToken);
            } catch {}

            set(x);
        }
    }))
);
